import 'theme/blue-angels'
import Buefy from 'buefy';

import Vue from 'vue';
import VueRouter from 'vue-router';
import ExternalQuotesPage from './routes/external/routes/externalQuotesPage/page';

Vue
  .use(Buefy, {
    defaultIconPack: 'fas',
    defaultIconComponent: 'fa',
  })
  .use(VueRouter);

let router = new VueRouter({
  routes: [
    {
      path: '/external/externalQuotesPage',
      redirect: '/external/externalQuotesPage/projectDetails'
    },
    {
      path: '/external/externalQuotesPage/:stage?',
      component: ExternalQuotesPage
    },
    {
      path: '*',
      redirect: '/external/externalQuotesPage/projectDetails'
    }
  ]
});

//create a container for the app
let container = document.createElement('div');
document.body.appendChild(container);

//init the base vue component
new Vue({
  router,
  template: `<router-view class="projectEstimator"></router-view>`,
}).$mount(container);
